import {isMembersVisible} from '../../../selectors/settings'
import {renderIfVisible} from '../../hoc/render-if-visible'
import {SingleEventMembers} from './members'

export const Members = renderIfVisible(SingleEventMembers, isMembersVisible)
export * from './interfaces'
